import { ASPECT_RATIO } from "@/react/components/constants";
import { CoverImageLoader } from "@circle-react/components/Layout/StandardLayoutV2/CoverImageLoader";
import { CoverImageInput } from "@circle-react-uikit/CoverImageInput";
import { Form } from "@circle-react-uikit/Form";
import { CustomizeHome } from "./CustomizeHome";

export interface CustomizeHomeFormProps {
  coverImage: string;
  shouldShowCoverImageModal: boolean;
  toggleCoverImageModal: () => void;
  shouldShowCustomizeModal: boolean;
  toggleCustomizeModal: () => void;
  isCoverImageLoading: boolean;
  onAddCoverImage: (formValues: { cover_image: string }) => void;
  isDataRefreshing: () => boolean;
  initialSection: string;
}

export const CustomizeHomeForm = ({
  coverImage,
  shouldShowCoverImageModal,
  toggleCoverImageModal,
  shouldShowCustomizeModal,
  toggleCustomizeModal,
  isCoverImageLoading,
  onAddCoverImage,
  isDataRefreshing,
  initialSection,
}: CustomizeHomeFormProps) => (
  <>
    <Form
      defaultValues={{ cover_image: coverImage }}
      onSubmit={onAddCoverImage}
      className="hidden"
    >
      {({ triggerFormSubmit }) => (
        <CoverImageInput
          name="cover_image"
          renderer={({ processing }) => {
            const isLoading =
              processing || isCoverImageLoading || isDataRefreshing();
            return <CoverImageLoader isLoading={!coverImage && isLoading} />;
          }}
          onImageAttachSuccess={triggerFormSubmit}
          aspectRatio={ASPECT_RATIO.COVER_V3}
          showAddCoverBtn={false}
          isOpen={shouldShowCoverImageModal}
          onClose={toggleCoverImageModal}
        />
      )}
    </Form>
    <CustomizeHome
      shouldShowCustomizeModal={shouldShowCustomizeModal}
      toggleCustomizeModal={toggleCustomizeModal}
      initialSection={initialSection}
    />
  </>
);
